'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'

import { Price } from '../components/price/Price'
import type { ClientPriceProps } from '../types'

/**
 * @description
 * Renders a generic price with the possibility of adding crossed out prices. It is a client component
 *
 * @example
 * <ClientPrice prices={{price: 10}} />
 *
 * @example
 * <ClientPrice
 * prices={{
 * 		price: 10,
 * 		crossedOutPrices: [40, 30, 20],
 * 		discountRate: 50,
 * }}
 * horizontal
 * reverse
 * align="start"
 * additionalPriceVertical
 * hasMicrodata
 * hidePriceHistory
 * showDiscount
 * showDiscountInfo
 * classes={{
 * 		price: text.bodyL,
 * 		crossedOutPrices: '',
 * 		firstCrossedOutPrice: '',
 * 		discountRate: text.bodyS,
 * 		additionalPrice: '',
 * 		additionalFirstCrossedOutPrice: '',
 * 		additionalCrossedOutPrices: '',
 * }}
 * />
 *
 * @see {@link ServerPrice}
 */
export const ClientPrice = (props: ClientPriceProps) => {
	const {
		channel,
		country: { hasPriceHistory },
	} = useMasterData()

	const { t } = useLabels()

	return (
		<Price
			{...props}
			hasPriceHistory={hasPriceHistory}
			getLabel={t}
			channel={channel}
		/>
	)
}
